export interface RoutePermission {
  pattern: string
  permission: string
}

export const routePermissions: RoutePermission[] = [
  {
    pattern: '/lead-flows',
    permission: 'lop:ui:path:read:/lead-flows',
  },
  {
    pattern: '/lead-flows/new/*',
    permission: 'lop:ui:path:read:/lead-flows/new',
  },
  {
    pattern: '/lead-flows/:slug/edit/*',
    permission: 'lop:ui:path:read:/lead-flows/:slug/edit',
  },
  {
    pattern: '/tests',
    permission: 'lop:ui:path:read:/tests',
  },
  {
    pattern: '/tests/new/*',
    permission: 'lop:ui:path:read:/tests/new',
  },
  {
    pattern: '/tests/:id/edit/*',
    permission: 'lop:ui:path:read:/tests/:id/edit',
  },
  {
    pattern: '/bidding',
    permission: 'lop:ui:path:read:/bidding',
  },
  {
    pattern: '/bidding/new/*',
    permission: 'lop:ui:path:read:/bidding/new',
  },
  {
    pattern: '/bidding/:id/edit/*',
    permission: 'lop:ui:path:read:/bidding/:id/edit',
  },
  {
    pattern: '/pixels',
    permission: 'lop:ui:path:read:/pixels',
  },
  {
    pattern: '/pixels/new/*',
    permission: 'lop:ui:path:read:/pixels/new',
  },
  {
    pattern: '/pixels/:id/edit/*',
    permission: 'lop:ui:path:read:/pixels/:id/edit',
  },
  {
    pattern: '/partners',
    permission: 'lop:ui:path:read:/partners',
  },
  {
    pattern: '/partners/new',
    permission: 'lop:ui:path:read:/partners/new',
  },
  {
    pattern: '/partners/:id/edit',
    permission: 'lop:ui:path:read:/partners/:id/edit',
  },
  {
    pattern: '/users',
    permission: 'lop:ui:path:read:/users',
  },
  {
    pattern: '/users/new',
    permission: 'lop:ui:path:read:/users/new',
  },
  {
    pattern: '/users/:id/edit',
    permission: 'lop:ui:path:read:/users/:id/edit',
  },
  {
    pattern: '/admin/roles',
    permission: 'lop:ui:path:read:/admin/roles',
  },
  {
    pattern: '/admin/roles/new',
    permission: 'lop:ui:path:read:/admin/roles/new',
  },
  {
    pattern: '/admin/roles/:id/edit',
    permission: 'lop:ui:path:read:/admin/roles/:id/edit',
  },
  {
    pattern: '/admin/permissions',
    permission: 'lop:ui:path:read:/admin/permissions',
  },
  {
    pattern: '/admin/permissions/new',
    permission: 'lop:ui:path:read:/admin/permissions/new',
  },
  {
    pattern: '/admin/permissions/:id/edit',
    permission: 'lop:ui:path:read:/admin/permissions/:id/edit',
  },
  {
    pattern: '/sms-remarketing',
    permission: 'lop:ui:path:read:/sms-remarketing',
  },
  {
    pattern: '/sms-remarketing/new',
    permission: 'lop:ui:path:read:/sms-remarketing/new',
  },
  {
    pattern: '/sms-remarketing/:id/edit',
    permission: 'lop:ui:path:read:/sms-remarketing/:id/edit',
  },
  {
    pattern: '/sms-remarketing/:id/templates/new',
    permission: 'lop:ui:path:read:/sms-remarketing/:id/templates/new',
  },
  {
    pattern: '/sms-remarketing/:id/templates/:templateId/edit',
    permission:
      'lop:ui:path:read:/sms-remarketing/:id/templates/:templateId/edit',
  },
  {
    pattern: '/reporting',
    permission: 'lop:ui:path:read:/reporting',
  },
  {
    pattern: '/reporting/manual-spend',
    permission: 'lop:ui:path:read:/reporting/manual-spend',
  },
  {
    pattern: '/reporting/bid-outcomes',
    permission: 'lop:ui:path:read:/reporting/bid-outcomes',
  },
  {
    pattern: '/ai-chat',
    permission: 'lop:ui:path:read:/ai-chat',
  },
  {
    pattern: '/ai-chat/overview',
    permission: 'lop:ui:path:read:/ai-chat',
  },
  {
    pattern: '/ai-chat/conversations',
    permission: 'lop:ui:path:read:/ai-chat',
  },
  {
    pattern: '/ai-chat/corpus',
    permission: 'lop:ui:path:read:/ai-chat',
  },
  {
    pattern: '/ai-chat/prompt',
    permission: 'lop:ui:path:read:/ai-chat',
  },
  {
    pattern: '/ai-chat/transfer-hours',
    permission: 'lop:ui:path:read:/ai-chat',
  },
]
